export class CreateAppStatusTimerNotificationsRequest {
  suppressAlertReminders: boolean;
  suppressExpirationReminders: boolean;
}
